import { FC, SVGProps } from 'react'

export const AIMic: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="5.1665"
      y="1.83301"
      width="5.66667"
      height="8.33333"
      rx="2.83333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99984 12.6663C10.2855 12.6663 13.3332 10.6663 13.3332 7.33301M7.99984 12.6663C5.71412 12.6663 2.6665 10.6663 2.6665 7.33301M7.99984 12.6663V14.6663"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
